import { useCallback, useEffect, useState } from 'react';
import { injectIntl, InjectedIntl } from 'react-intl';

//@ts-ignore
import Modal from '@mindtickle/modal';
//@ts-ignore
import { reload } from '@mindtickle/utils';

import CookieChangeListeners from '@mindtickle/ui-shell-core/CookieChangeListeners';
import type { Types as CookieTypes } from '@mindtickle/ui-shell-core/CookieChangeListeners';

import { APPLICATIONS, getApplicationAccessLink } from '~/components/ApplicationUrls';
import { APP_NAME } from '~/config/app.constants';

import { withTranslationsInternal } from '~/components/Intl';

import messages from './messages';
import { inFrame } from '~/utils';

const SessionExpireListener = ({ intl }: { intl?: InjectedIntl }) => {
  const [sessionExpired, setSessionExpired] = useState(false);

  const onDelete = useCallback((cookies: CookieTypes.CookieList) => {
    setSessionExpired(true);
  }, []);

  const onChange = useCallback((cookies: CookieTypes.CookieList) => {
    // setSessionExpired(true);
  }, []);

  useEffect(() => {
    if (sessionExpired && !inFrame()) {
      Modal.info({
        title: intl!.formatMessage(messages.title),
        content: intl!.formatMessage(messages.content),
        closable: false,
        width: 400,
        footerBtnProps: {
          okButtonProps: {
            type: 'primary',
            size: 'medium',
          },
        },
        okButtonText: intl!.formatMessage(messages.loginBtn),
        onOk: () => reload(getApplicationAccessLink(APPLICATIONS.LOGIN)),
      });
    }
  }, [intl, sessionExpired]);
  return (
    <CookieChangeListeners
      onDelete={onDelete}
      onChange={onChange}
      cookiesToMonitor={['loggedOut']}
    />
  );
};

export default withTranslationsInternal({ appName: APP_NAME })(injectIntl(SessionExpireListener));
